/**
 * Math primitives for the simulation core.
 *
 * ## Frame conventions (load-bearing — every other module refers here)
 *
 * **World frame: local ENU.** X = east, Y = north, Z = up. The origin is the
 * scenario's `originLatLonAlt`. Gravity is `(0, 0, -9.80665)` m/s².
 *
 * **Body frame: FLU.** X = forward (nose), Y = left, Z = up. A multirotor's
 * net thrust acts along body +Z.
 *
 * **Orientation** is a unit quaternion mapping body → world:
 * `worldVec = rotateVec(q, bodyVec)`.
 *
 * **Euler angles** are intrinsic Z-Y-X (yaw about world +Z, then pitch about
 * the new +Y, then roll about the new +X). See ./quat.ts.
 *
 * **Angular rate** passed to `integrateAngularRate` is body-frame, rad/s.
 */
export * from './vec3';
export * from './quat';
export * from './geo';

export const GRAVITY = 9.80665;
export const DEG2RAD = Math.PI / 180;
export const RAD2DEG = 180 / Math.PI;

export const clamp = (v: number, lo: number, hi: number): number => (v < lo ? lo : v > hi ? hi : v);

export const lerpScalar = (a: number, b: number, t: number): number => a + (b - a) * t;

/** Wrap an angle to (-π, π]. */
export const wrapPi = (a: number): number => {
  let x = (a + Math.PI) % (2 * Math.PI);
  if (x <= 0) x += 2 * Math.PI;
  return x - Math.PI;
};
